import { WizardStepStatus } from '../types';

export type WizardStepsContextType = {
  openStep: (stepName: string) => void;
  nextStep: (currentStepName: string) => void;
  getStep: (stepName: string) => WizardStepsStep;
};

export type WizardStepsStep = {
  stepNumber: number;
  status: WizardStepStatus;
  isOpen: boolean;
};

export type WizardStepsState = {
  steps: {
    [stepName: string]: WizardStepsStep;
  };
};

export type OpenStepAction = {
  type: WizardStepsActionType.OPEN_STEP;
  payload: {
    stepName: string;
  };
};

export type NextStepAction = {
  type: WizardStepsActionType.NEXT_STEP;
  payload: {
    currentStepName: string;
  };
};

export type WizardStepsAction = NextStepAction | OpenStepAction;
export enum WizardStepsActionType {
  NEXT_STEP = 'NEXT_STEP',
  OPEN_STEP = 'OPEN_STEP',
}
